// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1buCB","active":"downloadDropdown_active__2oNzC"};